// extracted by mini-css-extract-plugin
export var faq = "blogPost-module--faq--7279b";
export var main = "blogPost-module--main--febad";
export var nav = "blogPost-module--nav--876cd";
export var relatedPosts = "blogPost-module--related-posts--f97fd";
export var sidebar = "blogPost-module--sidebar--40b67";